import { createContext, useContext, useState, useEffect } from 'react'
import { disconnectPush, resumePushSession } from '../shared/lib/pushClient'

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try { return localStorage.getItem('token') ? JSON.parse(localStorage.getItem('user')) : null }
        catch { return null }
    })
    const [token, setToken] = useState(() => localStorage.getItem('user') ? localStorage.getItem('token') : null)
    const loading = false

    const login = (userData, userToken) => {
        if (token && user?.id !== userData.id) disconnectPush(token, user?.id).catch(() => {})
        resumePushSession(userToken)
        setUser(userData)
        setToken(userToken)
        localStorage.setItem('token', userToken)
        localStorage.setItem('user', JSON.stringify(userData))
    }

    const logout = () => {
        disconnectPush(token, user?.id).catch(error => console.error('Не удалось отвязать push-подписку на сервере:', error.message))
        setUser(null)
        setToken(null)
        localStorage.removeItem('token')
        localStorage.removeItem('user')
    }

    const updateSession = (userData, userToken) => {
        resumePushSession(userToken)
        setUser(userData)
        setToken(userToken)
        localStorage.setItem('token', userToken)
        localStorage.setItem('user', JSON.stringify(userData))
    }

    useEffect(() => {
        const synchronize = () => {
            const nextToken = localStorage.getItem('token')
            const savedUser = localStorage.getItem('user')
            if (!nextToken || !savedUser) {
                disconnectPush(token, user?.id).catch(() => {})
                setToken(null)
                setUser(null)
                return
            }
            try {
                const nextUser = JSON.parse(savedUser)
                const payload = JSON.parse(atob(nextToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
                if (Number(payload.sub || payload.id) !== Number(nextUser.id)) return
                resumePushSession(nextToken)
                setToken(nextToken)
                setUser(nextUser)
            } catch { /* Wait for a complete valid session to arrive from the other tab. */ }
        }
        const onStorage = event => { if (['token', 'user'].includes(event.key) || event.key === null) synchronize() }
        window.addEventListener('storage', onStorage)
        return () => window.removeEventListener('storage', onStorage)
    }, [token, user?.id])

    return (
        <AuthContext.Provider value={{ user, token, login, logout, updateSession, loading }}>
            {children}
        </AuthContext.Provider>
    )
}

// The provider and its context hook intentionally share this module.
// eslint-disable-next-line react-refresh/only-export-components
export const useAuth = () => useContext(AuthContext)
